import { $, $$, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';

function init() {
  if (!$('[data-au-downloads]')) return;

  addEventListeners();
  buildSlider();
}

function addEventListeners() {
  $$('[data-au-downloads-related-target]').forEach((downloadSelector) => {
    downloadSelector.addEventListener('click', (e) => toggleDownload(e));
  });
}

function hideAllRelatedContents(el) {
  el.classList.remove('au-active');
  el.classList.add('au-hide');
}

function showThisRelatedContent(el) {
  const downloadSlider = el.querySelector('[data-au-downloads-slider]'),
    downloadDropdown = el.querySelector('[data-au-collapsable]'),
    downloadDropdownContent = el.querySelector('[data-au-collapsable-content]');

  el.classList.remove('au-hide');
  el.classList.add('au-active');

  // update slider when show it, to recalculate scrollbar width on mobile
  if (downloadSlider && downloadSlider.swiper) {
    downloadSlider.swiper.update();
  }

  // open related dropdown if exists. Timeout to show animation correctly. If not, it appears directly, without animation
  if (downloadDropdown && downloadDropdownContent) {
    setTimeout(() => {
      downloadDropdown.classList.remove('au-closed');
      downloadDropdown.setAttribute('aria-expanded', 'true');
      downloadDropdownContent.classList.remove('au-closed');
      downloadDropdownContent.setAttribute('aria-expanded', 'true');
      downloadDropdownContent.querySelectorAll('[data-au-dropdown-option-btn]').forEach((option) => {
        option.removeAttribute('tabindex');
      });
    }, 100);
  }
}

function showRelatedContentOfActiveButton(relatedContent) {
  relatedContent.querySelectorAll('[data-au-downloads-related-target]').forEach((el) => {
    if (el.classList.contains('au-active')) {
      const relatedContent = el.dataset.auDownloadsRelatedTarget
        ? $(`[data-au-downloads-related-content=${el.dataset.auDownloadsRelatedTarget}]`)
        : null;
      showThisRelatedContent(relatedContent);
    }
  });
}

function toggleDownload(e) {
  const target = e.target,
    allRelatedContents = target.closest('[data-au-downloads]').querySelectorAll('[data-au-downloads-related-content]'),
    thisParent = target.closest('[data-au-downloads-related-content]'),
    relatedContent = target.dataset.auDownloadsRelatedTarget
      ? $(`[data-au-downloads-related-content=${target.dataset.auDownloadsRelatedTarget}]`)
      : null;

  // hide all elements but its parent and the related content
  if (relatedContent !== null) {
    allRelatedContents.forEach((relatedContent) => {
      if (relatedContent !== thisParent) {
        hideAllRelatedContents(relatedContent);
      }
    });

    // show related content
    showThisRelatedContent(relatedContent);

    // show related content of active button, inside dropdown, on change selector
    showRelatedContentOfActiveButton(relatedContent);
  }
}

function buildSlider() {
  $$('[data-au-downloads-slider]').forEach((slider) => {
    const downloadSliderWrapper = slider.querySelector('[data-au-download-slider-wrapper]'),
      downloadSliderControls = slider.querySelector('[data-au-slider-controls]'),
      downloadSlides = slider.querySelectorAll('[data-au-download-slide]'),
      downloadSlidesLength = downloadSlides.length;

    if (downloadSlidesLength > 1) {
      new Swiper(slider, {
        modules: [Navigation, Scrollbar, A11y, FreeMode],
        ...sliderConfig,
      });
      if (downloadSlidesLength === 2) {
        downloadSlides.forEach((slide) => {
          slide.classList.add('au-downloads__slide--duo');
        });
      }
    } else {
      downloadSliderWrapper.classList.add('au-downloads__slider-wrapper--centered');
      downloadSliderControls.classList.add('au-hide');
      downloadSlides.forEach((slide) => {
        slide.classList.add('au-downloads__slide--single');
      });
    }
  });
}

export default { init };
